module.exports = __webpack_public_path__ + "app/kiss-seller/modal-sub-entity/modal-pdp-subEntity-TQj45hie.html";